/* eslint-env node */
// Logika MURNI untuk detail Ormas Badan Hukum (respons /getDetailBadanHukum).
// Sengaja TANPA import Vuex/Vue agar bisa diuji dengan Node biasa
// (lihat src/helpers/__tests__/badanHukum.test.js).

// Urutan prioritas kunci file pengurus. AHU (per 2026-10) TIDAK mengirim file untuk pengurus;
// kunci ini disiapkan bila sumber data kelak menambahkannya.
var PENGURUS_FILE_KEYS = ['file_identitas', 'path_file', 'file'];

/**
 * Ambil path file dokumen pengurus badan hukum, atau null bila tidak ada.
 * PENTING: no_ktp_passport_pengurus adalah NIK, BUKAN path file — jangan dipakai sebagai URL
 * (dulu dipakai dan menghasilkan api-file.../<NIK> yang 404).
 * @param {object} item — satu elemen `pengurus` ({ data: {...} }) dari /getDetailBadanHukum.
 * @returns {string|null}
 */
function getPengurusFilePath(item) {
  var data = item && item.data;
  if (!data || typeof data !== 'object') return null;
  for (var i = 0; i < PENGURUS_FILE_KEYS.length; i++) {
    var value = data[PENGURUS_FILE_KEYS[i]];
    if (typeof value === 'string' && value.trim() !== '') return value.trim();
  }
  return null;
}

function hasItems(list) {
  return Array.isArray(list) && list.length > 0;
}

function jenisFromPengurus(list) {
  var first = list[0];
  var jenis = first && first.data && first.data.jenis_pengurus;
  if (jenis === 'ORGAN PERKUMPULAN') return 1;
  if (jenis === 'ORGAN YAYASAN') return 2;
  return 0;
}

/**
 * Tentukan jenis ormas badan hukum: 1 = Perkumpulan, 2 = Yayasan, 0 = tidak diketahui.
 * Backward compatible: bila `pengurus` berisi data, hasilnya SAMA PERSIS dengan logika lama
 * (pengurus[0].data.jenis_pengurus). Fallback hanya dipakai saat `pengurus` null/kosong —
 * AHU bisa mengembalikan pengurus null pada data pendirian (pengurus hanya ada di
 * `sk_terakhir.pengurus`), kasus yang sebelumnya membuat halaman error.
 * Urutan fallback: sk_terakhir.pengurus -> jenis_entitas.
 * @param {object} detail — satu item `data` dari respons /getDetailBadanHukum.
 * @returns {number}
 */
function resolveJenisOrmasBadanHukum(detail) {
  if (!detail) return 0;
  if (hasItems(detail.pengurus)) return jenisFromPengurus(detail.pengurus);

  var skPengurus = detail.sk_terakhir && detail.sk_terakhir.pengurus;
  if (hasItems(skPengurus)) {
    var jenis = jenisFromPengurus(skPengurus);
    if (jenis) return jenis;
  }

  var entitas = String(detail.jenis_entitas || '').toUpperCase();
  if (entitas === 'PERKUMPULAN') return 1;
  if (entitas === 'YAYASAN') return 2;
  return 0;
}

module.exports = {
  getPengurusFilePath: getPengurusFilePath,
  resolveJenisOrmasBadanHukum: resolveJenisOrmasBadanHukum
};
